<template>
	<div class="box">
		<ul class="tableHeader tableHeaderbox">
			<li v-for="item in tableList">{{item.tableName}}</li>
		</ul>
		<!--  -->
		<div class="tabletd" @scroll="scrollEvent($event)">
			<ul class="tablecontent tableHeader" v-for="item in datalist">
				<li>{{item.id}}</li>
				<li>{{item.uName}}</li>
				<li>{{item.uTel}}</li>
				<li>{{item.tName}}</li>
				<li>
					<p v-if="item.uChecked==0&&item.uAuthImg==''">初级认证</p>
					<p v-if="item.uChecked==40">（初级升高级）</p>
				</li>
				<li>
					<span v-if="item.uAuthImg" @click="yyxkImgFn(item.uAuthImg)"><i class="el-icon-search"></i>医师执业许可证</span>
					<span v-if="!item.uAuthImg">无</span>
				</li>
				<li>
					<div class="btns"  @click="checked_usersFn(4,item.id,item.uTypeID,item.uChecked)">
						<button :disabled="tongguo">初级认证</button>
					</div>
					<div class="btns"  @click="checked_usersFn(1,item.id,item.uTypeID,item.uChecked)">
						<button :disabled="tongguo">高级认证</button>
					</div>
					<div  class="btns" @click="bhFn($event)">
						<button >驳回</button>
					</div>
					<div class="dialogBh">
						<div class="header">
							<p><i class="el-icon-close" @click="gbFn"></i></p>
							<p>驳回理由</p>
						</div>
						<div class="content">
							<textarea class="textarea_conent" v-model="bhcontents" name="" rows="" cols=""></textarea>
						</div>
						<div class="footer">
							<div class="btn">
								<button :disabled="tongguo" @click="checked_usersFn(2,item.id,item.uTypeID,item.uChecked)">
									确定
								</button>
							</div>
						</div>
					</div>
				</li>
			</ul>
			<div class="list-more" v-show="deviceTip">
				<p>{{deviceTip}}</p>
			</div>
		</div>
		<el-dialog
		  title=""
		  :visible.sync="centerDialogVisible"
		  width="80%"
		  center>
		  <img style="text-align: center;width: 100%;" :src="'http://api.bats-bio.com'+DialogImg"/>
		  <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="centerDialogVisible = false">关 闭</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	import config from '../../http/config.js'
	import {users_list,checked_users,set_dual_status,user_save} from '../../http/api.js'
	export default{
		components:{
		},
		data(){
			return{
				pageIndex:1,
				datalist:[],
				total: 0, //总条数
			    pageCount: 0, //总页数
			    isRequestData:true,

				tableData:null,
				jgfkBool:false,
				yuyueBool:false,
				tableList:[{
						tableName:'认证序号',
					},{
						tableName:'姓名',
					},{
						tableName:'手机号',
					},{
						tableName:'认证身份',
					},{
						tableName:'认证类别',
					},{
						tableName:'认证材料',
					},{
						tableName:'操作',
					}
				],
				ddBool:null,
				zlBool:null,
				ycBool:'',
				yc2Bool:'',
				devicePageSize: 10, //每页显示
			    devicePageNum: 1, //当前页
			    devicePageTotal: 0, //总条数
			    devicePageTotalPages: 0, //总页数
			    deviceListIsFinish: false, //是否加载完成
			    deviceListIsLoad: false, //是否加载更多
			    deviceListnodata: false, //是否有数据
			    deviceTip: "",
			    deviceList:[],
			    deviceRow:{},
			    companysrow:{},
				yyzzImg:'',
				yyxkImg:'',
				bhtjVal:'缺少认证材料',
				tongguo:false,
				DialogImg:'',
				centerDialogVisible:false,
				bhcontents:''
				
			}
		},
		mounted () {
			this.users_listFn();
		},
		methods: {
			users_listFn () {
				let data = {
		      		page:this.devicePageNum,
      				limit:this.devicePageSize,
      				user_type:'1,2,3',
      				rz:'0,40'
		      	}
		      	users_list(data).then(res=>{
		      		if(res.result==0){
	      				this.devicePageTotal = res.total;
	      				//需要加当前页和每页显示
	//			        this.devicePageSize = res.pageSize;
	//			        this.devicePageNum = res.pageNum;
				        this.devicePageTotalPages=res.count;
				        if(res.data==''){
				            this.deviceListnodata = true;
				            this.deviceListIsLoad = false;
				            this.deviceListIsFinish = true;
				            this.devicePageNum = 1;
				            this.deviceTip = "暂无数据";
				            return false;
				        }else{
				        	if(res.count<this.devicePageSize){
				        		this.deviceListnodata = true;
					            this.deviceListIsLoad = false;
					            this.deviceListIsFinish = true;
					            this.devicePageNum = 1;
					            this.deviceTip = "暂无数据";
//					            return false;  	
				        	}else{
					        	this.deviceListIsLoad = true;
					            this.deviceListIsFinish = false;
					            this.devicePageNum++;
					            this.deviceTip = "正在加载中~";
				        		
				        	}
				        }
//				        for(var i = 0; i<res.data.length;i++){
//				        	if(res.data[i].uChecked==3){
//				        		this.datalist.push(res.data[i]);
//				        	}
//				        }
						this.datalist = this.datalist.concat(res.data);
	      			}else{
	      				this.deviceListIsLoad = false;
				        this.deviceListIsFinish = true;
				        this.devicePageNum = 1;
				        this.deviceTip = "数据加载失败~";
      				}
		      	});
			},
			scrollEvent (e) {
	    		if (e instanceof Event) {
		        	let el = e.target;
		        	let scrollTop = el.scrollTop;
			        // 获取可视区的高度
			        let clientHeight = el.clientHeight;
			        // 获取滚动条的总高度
			        let scrollHeight = el.scrollHeight;
			        let height = 140;//一格表格的高
			        if ( scrollTop + clientHeight >= scrollHeight&&this.deviceListIsLoad &&!this.deviceListIsFinish) {
			        this.deviceListIsLoad = true;
//			        console.log("到底了");
			        var timer=setTimeout(() => {
			         	this.users_listFn();
			         	clearTimeout(timer)
			        }, 1000);
		        	}
	   	 		}	
	   		},
	   		getSex (sex) {
				return sex == 1?'男':'女';
			},
			getTime (dt) {
				let ay = dt.split(' ');
				return ay[0]+' '+ay[1].substr(0,5);
			},
			yyxkImgFn(str){
				this.centerDialogVisible=true;
				this.DialogImg=str;
			},
			hideImgFn(event){
				var el = event.currentTarget;
				$(el).siblings('img').css('display','none')
			},
//			yyzzImgFn(){
//				this.yyzzImg=true;
//				this.yyxkImg=false;
//			},
			imgCloseFn(){
				this.yyzzImg=false;
				this.yyxkImg=false;
			},
			checked_usersFn(val,id,type,check){
				this.tongguo=true;
				if(val==1){
					var data={
						uid:id,
						zt:1,
					}
					checked_users(data).then(res=>{
							console.log('1')
						if(res.result==1){
							this.$message({
					            message:res.msg,
					            type: 'success',
					            duration:1000,
					            onClose:()=>{
					            	this.datalist=[];
					            	this.devicePageSize= 10;//每页显示
			   						this.devicePageNum= 1;
					            	this.users_listFn();
					            	this.checkActiveFn(id);
					            	this.tongguo=false;
					         	}
							})
						}else{
							this.$message({
					            message:res.msg,
					            type: 'error',
					            duration:1000,
					            onClose:()=>{
					            	this.tongguo=false;
					         	}
							})
						}
						
					})
				}else if(val==2){
	            	$('.dialogBh').hide();
					if(check==0){
						var data1={
							uid:id,
							zt:2,
							remark:this.bhcontents
						}
					}else if(check==40){
						var data1={
							uid:id,
							zt:4,
							remark:this.bhcontents
						}
					}
					checked_users(data1).then(res=>{
						if(res.result==1){
							console.log('2')
							this.$message({
					            message:res.msg,
					            type: 'success',
					            duration:1000,
					            onClose:()=>{
					            	this.datalist=[];
					            	this.devicePageSize= 10;//每页显示
			   						this.devicePageNum= 1;
					            	this.users_listFn();
					            	$('.dialogBh').hide();
					            	this.tongguo=false;
					         	}
							})
						}else{
							this.$message({
					            message:res.msg,
					            type: 'error',
					            duration:1000,
					            onClose:()=>{
					            	$('.dialogBh').hide();
					            	
					         	}
							})
						}
					})
				}else if(val==4){
					var data={
						uid:id,
						zt:4,
					}
					checked_users(data).then(res=>{
						if(res.result==1){
							this.$message({
					            message:res.msg,
					            type: 'success',
					            duration:1000,
					            onClose:()=>{
					            	this.datalist=[];
					            	this.devicePageSize= 10;//每页显示
			   						this.devicePageNum= 1;
					            	this.users_listFn();
					            	this.checkActiveFn(id);
					            	this.tongguo=false;
					         	}
							})
						}else{
							this.$message({
					            message:res.msg,
					            type: 'error',
					            duration:1000,
					            onClose:()=>{
					            	this.tongguo=false;
					         	}
							})
						}
						
					})
				}
				this.tongguo=false;
				
			},
			set_dual_statusFn(id){
				var data={
					uid:id,
					zt:1
				}
				set_dual_status(data).then(res=>{
				})
			},
			bhFn(event){
				var el= event.currentTarget;
				$(el).siblings('.dialogBh').show();
				$(el).parent().parent().siblings().children().children('.dialogBh').hide();
			},
			gbFn(){
				$('.dialogBh').hide();
			},
			bhtjFn(event){
				var el = event.currentTarget;
				$(el).addClass('active');
				$(el).siblings().removeClass('active');
				this.bhtjVal=$(el).children('span').text()
				console.log(this.bhtjVal)
			},
			checkActiveFn(id){
				var data = {
					id: id,
					uIsAccDpc: 1,
					uIsAccPdm: 1
				}
				user_save(data).then(res => {
					
				})
			},
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
		position: relative;
	}
	.tableHeader{
		width: 100%;
		height: 20px;
		/*border-bottom: 1px solid #CCCCCC;*/
		background:#FFFFFF ;
	}
	.tableHeaderbox{
		padding-top: 50px;
		
	}
	.tabletd{
		position: absolute;
		top: 70px;
		left: 0;
		background:#F5F5F5 ;
		width: 100%;
		height: 720px;
		overflow: auto;
	}
	.tablecontent{
		width: 100%;
		height: 140px;
		border-bottom: 3px solid #FFFFFF;
		position: relative;
		background: #FDFBE5;
	}
	.tablecontent::before{
		content: "";
		display: none;
		position: absolute;
		top: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 2;
		background: #FEFDF7;
	}
	.tablecontent::after{
		content: "";
		display: none;
		position: absolute;
		bottom: 11px;
		left: 0;
		width: 100%;
		height: 50px;
		z-index: 2;
		background: #FEFDF7;
	}
	.tableHeader li ,.tablecontent li{
		float: left;
		text-align: center;
		font-size: 12px;
		color: #9B9B9B;
	}
	.tablecontent li{
		height: 140px;
		line-height: 140px;
		position: relative;
		color: #9B9B9B;
		/*z-index: 3;*/
	}
	.tablecontent li::before{
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 2px;
		height: 118px;
		border-left: 2px dashed #D7D9DC;/*px*/
	}
	.tablecontent li:nth-child(1) img{
		width: 73px;
		height: 98px;
		display: inline-block; 
		vertical-align: middle;
	}
	.tablecontent li:nth-child(5){
	}
	.tablecontent li:nth-child(5)>span{
		cursor: pointer;
	}
	.tablecontent li:nth-child(5) img{
		display: none;
		width:480px;
		height:329px;
		position: absolute;
		background: #FFFFFF;
		top: 100px;
		left: 0px;
		z-index: 4;
	}
	.tablecontent li:nth-child(7){
		font-size:11px;
		font-family:"微软雅黑";
		font-weight:600;
		color:rgba(155,155,155,1);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	div.btns{
		width:80px;
		height: 30px;
		/*position: relative;*/
	}
	div.btns:hover button{
		border: 2px solid yellow;
	}
	.tablecontent li:nth-child(7)>div:nth-child(2){
		margin-right: 10px;
		margin-left: 10px;
	}
	.tablecontent li:nth-child(7)>div>button{
		float: left;
		width:80px;
		height:30px;
		background:#0078FF;
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border-radius:3px;
		color: #FFFFFF;
		font-size: 11px;
		cursor: pointer;
		/*position: absolute;*/
	} 
	.tablecontent li:nth-child(1)::before{
		border: none;
	}
	
	.tableHeader li:nth-child(1){
		width: 10%;
	}
	.tableHeader li:nth-child(2){
		width: 10%;
	}
	.tableHeader li:nth-child(3){
		width: 12%;
	}
	.tableHeader li:nth-child(4){
		width:  8%;
	}
	.tableHeader li:nth-child(5){
		width:14%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.tableHeader li:nth-child(6){
		width: 15%;
		position: relative;
	}
	.tableHeader li:nth-child(7){
		width: 30%;
		position: relative;
	}
	.dialog-jgfk{
		width: 100%;
		height: 100%;
		background: #FFFFFF;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 111;
	}
	.commtitle{
		height: 70px;
		width: 100%;
		line-height: 70px;
		font-weight: 600;
		font-size:18px;
		color: #9B9B9B;
		border-bottom: 2px solid rgba(119,151,178,0.16);
		/*box-shadow:0px 2px 2px 0px rgba(119,151,178,0.16);*/
	}
	.commtitle>.el-icon-arrow-left{
		font-weight:bold ;
		color:#2E3458 ;
		margin-left: 20px;
		margin-right: 13px;
	}
	.zdcontent{
		width:100%;
		height:719px;
		background:#F5F5F5;
		box-shadow:0px 0px 2px 0px rgba(119,151,178,0.16);
	}
	.list-more{
		width: 100%;
		height: 100px;
		line-height: 100px;
		text-align: center;
		font-size: 12px;
	}
	.dialogBh{
		width:312px;
		height:331px;
		padding: 30px 30px; 
		background:rgba(255,255,255,1);
		box-shadow:4px 0px 12px 0px rgba(0,0,0,0.13);
		border-radius:10px;
		position: absolute;
		top: 97px;
		left: -44px;
		display: none;
		z-index: 999;
	}
	.header>p>i{
		font-size: 18px;
		color: #000000;
		float: right;
		cursor: pointer;
	}
	.header{
		/*height: 74px;*/
		padding-bottom: 12px;
		border-bottom: 2px solid rgba(241, 241, 241, 1);
	}
	.header>p{
		overflow: hidden;
		
	}
	.header>p:nth-child(2){
		text-align: left;
		font-size:18px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(0,0,0,1);
		line-height:25px;
	}
		.radiodiv:hover span{
		color: #3B97FF;
	}
	.radiodiv{
		margin-left: 2px;
		margin-top:20px ;
		font-size:14px;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(0,0,0,1);
		line-height:20px;
		overflow: hidden;
		cursor: pointer;
	}
	.radiodiv>i.check{
		float: left;
		display: block;
		width: 20px;
		height: 20px;
		border-radius:50% ;
		background: url(../../../assets/image/圈未选中.png) no-repeat center center;
		background-size:100% ;
	}
	.radiodiv.active>i.check{
		background: url(../../../assets/image/选中.png) no-repeat center center;
		background-size:100% ;
	}
	.radiodiv.active>span{
			color: #3B97FF;
	}
	.radiodiv>span{
		height:34px;
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(0,0,0,1);
		line-height:20px;
		float: left;
		margin-left: 10px;	
	}
	.footer{
		height:40px;
	}
	.footer>.btn{
		width:311px;
		height:40px;
		margin-top: 10px;
	}
	.footer>.btn:hover button{
		border: 2px solid yellow;
	}
	.footer>.btn>button{
		width:311px;
		height:40px;
		background:rgba(0,120,255,1);
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border: none;
		border-radius:3px;
		font-size:14px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(255,255,255,1);
		float: left;
	}
	.textarea_conent{
		margin-top: 20px;
		width: 100%;
		height: 100px;	
		font-size:14px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		resize: none;
	}
</style>
<style type="text/css">
	.el-dialog--center .el-dialog__body{
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/MA/accountManagement/doctorProbate.vue